import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { SkapaTokens } from '@inter-ikea-guida/skapa';
import { useGuidaUIStates } from '../hooks/useGuidaUIStates';
import { KOMPIS_HEADER_HEIGHT, SIDEBAR_WIDTH } from '../utils/constants';
export const StyledContent = styled.div `
  width: 100%;
  height: calc(100vh - ${KOMPIS_HEADER_HEIGHT});
  overflow-y: auto;
  padding-inline-end: ${props => (props.$isSidebarMode ? SkapaTokens.space150 : 0)};

  @media (min-width: ${SkapaTokens.breakpointXl}) {
    width: calc(100% - ${SIDEBAR_WIDTH}px);
  }
`;
const StyledRecommendationsContainer = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${SkapaTokens.space150};
  height: ${$isSidebarMode => ($isSidebarMode ? `calc(100vh - ${KOMPIS_HEADER_HEIGHT})` : 'unset')};
  overflow-y: ${$isSidebarMode => ($isSidebarMode ? 'auto' : 'unset')};
  padding-inline-end: ${props => (props.$isSidebarMode ? SkapaTokens.space150 : 0)};
`;
export const GuidaMainContent = ({ children, isSidebarMode }) => {
    return _jsx(StyledContent, { "$isSidebarMode": isSidebarMode, children: children });
};
export const GuidaRecommendationsContainer = ({ children }) => {
    const { isSidebarMode } = useGuidaUIStates();
    return (_jsx(StyledRecommendationsContainer, { "data-testid": 'recommendations-container', "$isSidebarMode": isSidebarMode, children: children }));
};
//# sourceMappingURL=GuidaMainContent.js.map